<template>
  <div class="page_salary">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <div v-if="activeName2=='0'">
              <el-form-item label="归属月" size="small" label-width="70px">
                <el-date-picker v-model="listQuery.AttrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="发薪主体" size="small">
                <el-select v-model="listQuery.PayrollCompany" placeholder="" value-key="PayrollCompany" size="small" style="width: 180px;" clearable filterable>
                  <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="项目名称" size="small">
                <el-select v-model="listQuery.ProjectName" placeholder="" value-key="StrprojectName" size="small" style="width: 180px;" clearable filterable>
                  <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-if="activeName2=='1' || activeName2=='2' || activeName2=='3'">
              <el-form-item label="姓名" size="small">
                <el-input v-model="listQuery.EmployeeName" size="small" style="width: 180px;" clearable></el-input>
              </el-form-item>
              <el-form-item label="身份证" size="small">
                <el-input v-model="listQuery.CardId" size="small" style="width: 180px;" clearable></el-input>
              </el-form-item>
              <el-form-item label="银行卡" size="small">
                <el-input v-model="listQuery.BankAccount" size="small" style="width: 180px;" clearable></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
          <div v-if="activeName2=='0'">
            <div>
              <el-form-item label="商务合同主体" size="small" label-width="98px">
                <el-select v-model="listQuery.Subject" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                  <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发放途径" size="small">
                <el-select v-model="listQuery.PayrollChannel" placeholder="" clearable style="width: 180px;" filterable>
                  <el-option value="银行"></el-option>
                  <el-option value="灵活用工"></el-option>
                  <el-option value="安心云"></el-option>
                  <el-option value="现金"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发薪编号" size="small">
                <el-input v-model="listQuery.PayrollNum" size="small" style="width: 180px;" clearable></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="客户名称" size="small" label-width="98px">
                <el-input v-model="listQuery.CustomerName" size="small" style="width: 180px;" clearable></el-input>
              </el-form-item>
              <el-form-item label="客服" size="small">
                <el-select v-model="listQuery.Service" placeholder="" clearable style="width: 180px;" filterable>
                  <el-option v-for="(item,index) in customerList" :key="index" :value="item.Username"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业绩归属人" size="small">
                <el-select v-model="listQuery.StrAchieveowner" placeholder="" clearable style="width: 180px;" filterable>
                  <el-option v-for="(item,index) in customerList" :key="index" :value="item.Username"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="时间类型" size="small" label-width="98px">
                <el-select v-model="listQuery.SearchTimeType" style="width: 180px;" placeholder="" clearable filterable>
                  <el-option label="申请时间" value="1"></el-option>
                  <el-option label="发放时间" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开始时间">
                <el-date-picker v-model="listQuery.StartTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;" :disabled="!listQuery.SearchTimeType">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间">
                <el-date-picker v-model="listQuery.EndTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;" :disabled="!listQuery.SearchTimeType">
                </el-date-picker>
              </el-form-item>
            </div>
            <div v-if="activeName=='已发薪'">
              <el-form-item label="算税状态" size="small" label-width="98px">
                <el-select v-model="listQuery.TaxBureauResults" style="width: 180px;" placeholder="" clearable filterable>
                  <el-option value="已算税"></el-option>
                  <el-option value="未算税"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div v-if="activeName2=='1' || activeName2=='2' || activeName2=='3'">
            <div>
              <el-form-item label="手机号" label-width="118px" size="small">
                <el-input v-model="listQuery.PhoneNum" size="small" style="width: 180px;" clearable></el-input>
              </el-form-item>
              <el-form-item label="发薪编号" size="small" label-width="87px">
                <el-input v-model="listQuery.PayrollNum" size="small" style="width: 180px;" clearable></el-input>
              </el-form-item>
              <el-form-item label="申报月" size="small" v-if="activeName2=='1' && activeName=='已发薪'">
                <el-date-picker v-model="listQuery.IncomeTaxMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
                </el-date-picker>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="项目名称" size="small" label-width="118px">
                <el-select v-model="listQuery.ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                  <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发薪主体" size="small" label-width="87px">
                <el-select v-model="listQuery.PayrollCompany" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                  <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="时间类型" size="small" label-width="118px">
                <el-select v-model="listQuery.SearchTimeType" style="width: 180px;" placeholder="" clearable filterable>
                  <el-option label="申请时间" value="1"></el-option>
                  <el-option label="发放时间" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开始时间">
                <el-date-picker v-model="listQuery.StartTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;" :disabled="!listQuery.SearchTimeType">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间">
                <el-date-picker v-model="listQuery.EndTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;" :disabled="!listQuery.SearchTimeType">
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div v-if="activeName=='已发薪' && activeName2=='1'">
            <el-form-item label="校验状态" size="small" label-width="118px">
              <el-select v-model="listQuery.SendState" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option label="校验成功" value="4"></el-option>
                <el-option label="校验中" value="2"></el-option>
                <el-option label="校验失败" value="3"></el-option>
                <el-option label="未校验" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="算税状态" size="small">
              <el-select v-model="listQuery.TaxBureauResults" style="width: 180px;" placeholder="" clearable filterable>
                <el-option value="算税成功"></el-option>
                <el-option value="算税失败"></el-option>
                <el-option value="未算税"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs2 flex">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>发薪</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="payTips" style="margin-left:542px">注：撤销功能到待发薪流程时需联系相应出纳，前面流程可自行撤销。</div>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane :label="'算薪（' + num1 + '）'" name="算薪" v-if="roleName && roleName!='客户在线'"></el-tab-pane>
          <el-tab-pane :label="'安排资金（' + num10 + '）'" name="安排资金" v-if="activeName == '待发薪'"></el-tab-pane>
          <el-tab-pane :label="'客服主管审批（' + num2 + '）'" name="主管审批" v-if="checkPermission(['salary_manager'],permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'业务审批（' + num3+ '）'" name="业务审批" v-if="checkPermission(['salary_business'],permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'出纳确认（' + num4 + '）'" name="出纳确认" v-if="checkPermission(['salary_cashier'],permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'待发薪（' + num5 + '）'" name="待发薪" v-if="checkPermission(['salary_pendingSalary'],permissionLists)"></el-tab-pane>
          <el-tab-pane label="复核发薪" name="复核发薪" v-if="checkPermission(['salary_pendingSalary'],permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'打款中（' + num11 + '）'" name="打款中" v-if="checkPermission(['salary_part'],permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'部分发薪（' + num6 + '）'" name="部分发薪" v-if="checkPermission(['salary_part'],permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'已发薪（' + num7 + '）'" name="已发薪" v-if="checkPermission(['salary_completed'],permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'发薪失败（' + num8 + '）'" name="发薪失败" v-if="checkPermission(['salary_fail'],permissionLists)"></el-tab-pane>
          <el-tab-pane label="已发薪归档" name="已发薪归档" v-if="checkPermission(['salary_completed'],permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'退回记录（' + num9 + '）'" name="退回记录" v-if="checkPermission(['salary_back'],permissionLists)"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex">
          <el-button type="warning" v-if="activeName=='发薪失败' && activeName2=='2'" size="small" @click="batchSubmit" v-preventReClick :loading="isExpLoading">批量提交</el-button>
          <el-button type="warning" v-if="activeName=='发薪失败' && activeName2=='2'" size="small" @click="FailurePayToArchive" v-preventReClick :loading="isExpLoading">无需处理</el-button>
          <el-button type="warning" v-if="activeName=='发薪失败' && activeName2=='3'" size="small" @click="rePay" v-preventReClick :loading="isExpLoading">重新发薪</el-button>
          <el-button type="primary" size="small" @click="exportList" :loading="isExpLoading" v-preventReClick>导出</el-button>
          <el-button type="success" v-if="activeName=='发薪失败' && activeName2=='3'" size="small" @click="handel('1')" v-preventReClick :loading="isHandelLoading">手工登记成功</el-button>
          <el-button type="danger" v-if="activeName=='发薪失败' && activeName2=='3'" size="small" @click="handel('0')" v-preventReClick :loading="isHandelLoading">手工登记失败</el-button>
          <el-button type="primary" style="background:rgba(199, 21, 133, 1);color:#fff;border-color: rgba(199, 21, 133, 1);" size="small" v-if="activeName=='发薪失败' && activeName2=='3'" @click="selectRePay()">重选账户发薪</el-button>
          <el-button type="danger" style="background-color: #D9001B;" v-if="activeName=='发薪失败' && activeName2=='3'" size="small" @click="generalDisHandle" v-preventReClick :loading="isCbsLoading">CBS普通代发</el-button>

          <el-button type="warning" v-if="activeName=='已发薪' && roleName!='客户在线'&& checkPermission(['salary_downReceipt'],permissionLists)" @click="downReceiptBatch()" size="small">批量下载回单</el-button>

          <!-- <el-button type="primary" size="small" @click="exportSuccessDtl" :loading="isExpLoading" v-preventReClick v-if="activeName2=='1'">导出成功人员明细</el-button> -->
        </div>

        <el-tabs v-model="activeName2" v-if="activeName=='已发薪' || activeName=='发薪失败' || activeName=='已发薪归档'" @tab-click="changeTab2">
          <el-tab-pane label="失败人员明细" name="2" v-if="activeName=='发薪失败'" :disabled="loading"></el-tab-pane>
          <el-tab-pane label="按项目汇总" name="0" :disabled="loading"></el-tab-pane>
          <el-tab-pane label="成功人员明细" name="1" v-if="activeName=='已发薪' || activeName=='已发薪归档'" :disabled="loading"></el-tab-pane>
          <el-tab-pane label="待财务处理" name="3" v-if="activeName=='发薪失败'" :disabled="loading"></el-tab-pane>
          <el-tab-pane label="无需处理" name="4" v-if="activeName=='发薪失败'" :disabled="loading"></el-tab-pane>
          <el-tab-pane label="发薪成功导出记录" name="5" v-if="activeName=='已发薪'" :disabled="loading"></el-tab-pane>
          <!-- <el-tab-pane label="打款中" name="4" v-if="activeName=='部分发薪'"></el-tab-pane> -->
        </el-tabs>


        <el-table :data="tableData" border class="doc_table" v-loading="loading" :element-loading-text="loadingTxt ? loadingTxt : '加载中...'" style="width:100%" v-if="activeName2=='0'" @selection-change="handleSelectionChange2" :max-height="tableHeight-180">
          <el-table-column key="s2" type="selection" width="40" fixed="left">
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="AttrMonth" label="归属月" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ApplicationDate" label="发薪日" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PayType" label="发薪类型" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PayrollChannel" label="发放途径" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="TotalPayrolls" label="发薪人数" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="TotalResponse" label="应发金额" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="GrandTotal" label="实发金额" width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <div style="color:#ec5656;background:yellow">{{row.GrandTotal}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="CTotalPayrolls" label="已发人数" width="130" :show-overflow-tooltip="true" align="center" v-if="activeName == '待发薪'">
          </el-table-column>
          <el-table-column prop="SumIssuedThisMonth" label="待发金额" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName == '待发薪'">
          </el-table-column>
          <el-table-column prop="SumIssuedThisMonth" label="发薪成功金额" width="130" :show-overflow-tooltip="true" align="center" v-if="activeName == '已发薪' || activeName=='已发薪归档'">
          </el-table-column>
          <el-table-column prop="CTotalPayrolls" label="发薪成功人数" width="130" :show-overflow-tooltip="true" align="center" v-if="activeName == '已发薪' || activeName=='已发薪归档'">
          </el-table-column>
          <el-table-column prop="SumIssuedThisMonth" label="已发金额" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName == '部分发薪'">
          </el-table-column>
          <el-table-column prop="CTotalPayrolls" label="发薪失败人数" width="130" :show-overflow-tooltip="true" align="center" v-if="activeName == '发薪失败'">
          </el-table-column>
          <el-table-column prop="SumIssuedThisMonth" label="失败金额" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName == '发薪失败'">
          </el-table-column>
          <el-table-column prop="CTotalPayrolls" label="已发人数" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName == '部分发薪'">
          </el-table-column>
          <el-table-column prop="name" label="待发金额" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName == '部分发薪'">
            <template slot-scope={row}>
              {{( Number(row.GrandTotal) - Number(row.SumIssuedThisMonth)).toFixed(2)}}
            </template>
          </el-table-column>
          <el-table-column prop="AmountSocialSecurityFund" label="社保公积金" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PersonalIncomeTax" label="个税" width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="AdvancesEmployees" label="借支" width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="NeedApplyDeposit" label="申请垫支" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PayrollNum" label="发薪编号" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Subject" label="商务合同主体" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PayrollCompany" label="发薪主体" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CustomerName" label="客户名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ProcessState" label="流程状态" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PayScaleRUL" label="导入表附件" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CustomerOriginalTableRUL" label="客户原表附件" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark1" label="申请备注" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Operator" label="申请人" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="taxState" v-if="(activeName=='已发薪' || activeName=='已发薪归档') && activeName2=='0'" label="算税状态" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ApplyforTime" label="申请时间" width="150" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.ApplyforTime ? row.ApplyforTime.replace('T',' ') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="PaymentTime" label="发放时间" width="150" :show-overflow-tooltip="true" align="center" v-if="activeName == '已发薪' || activeName=='已发薪归档'">
            <template slot-scope={row}>
              {{ row.PaymentTime ? row.PaymentTime.replace('T',' ') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="Cashier " label="发薪出纳" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName!='已发薪' || activeName=='已发薪归档'">
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="200px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="toPayment(row)" v-if="(activeName=='待发薪' || activeName=='部分发薪') && checkPermission(['salary_payment'],permissionLists)">打款</el-button>
                <el-button type="text" @click="viewDtl(row)">明细</el-button>
                <el-button type="text" v-if="(activeName=='已发薪' || activeName=='已发薪归档') && roleName!='客户在线'&& checkPermission(['salary_downReceipt'],permissionLists)" @click="downReceipt(row.Id,row.CTotalPayrolls)">下载回单</el-button>
                <!-- <el-button type="text" v-if="activeName=='已发薪' && row.taxState=='未算税'" @click="taxCheck(row)">税局校验</el-button> -->
                <el-popconfirm title="请确定是否撤销？" @confirm="revoke(row)" style="margin-left: 10px;" v-if="(activeName=='待发薪' || activeName=='部分发薪') && checkPermission(['salary_pendingSalaryRevoke'],permissionLists)">
                  <el-button type="text" slot="reference">撤销</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="failData" border class="doc_table" v-loading="loading" :element-loading-text="loadingTxt ? loadingTxt : '加载中...'" style="width:100%" @selection-change="handleSelectionChange" v-if="activeName2!='0' && activeName2!='5' && (activeName=='已发薪' || activeName=='发薪失败' || activeName=='已发薪归档')" :max-height="tableHeight-180">
          <el-table-column key="s" type="selection" width="40" fixed="left">
          </el-table-column>
          <el-table-column prop="PayrollNum" label="发薪编号" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="AttrMonth" label="归属月" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Subject" label="商务合同主体" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PayrollCompany" label="发薪主体" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Cashier" label="发薪出纳" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CustomerName" label="客户名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="EmployeeName" label="员工姓名" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CardId" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IncludesTelephoneSubsidy" label="应发金额" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IssuedThisMonth" label="实发金额" width="90" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <div style="color:#ec5656;background:yellow">{{row.IssuedThisMonth}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="BankAccount" label="银行账号" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="DepositBank" label="开户行" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="name" label="开户地" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <!-- <el-table-column prop="name" label="打款状态" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="PayType" label="发放类型" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="DistributionChannel" label="发放途径" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark" label="备注" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="批次" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName2!='2'">
          </el-table-column>
          <el-table-column prop="PayErrMsg" label="失败原因" width="200" :show-overflow-tooltip="true" align="center" v-if="activeName2=='2'||activeName2=='3'">
          </el-table-column>
          <el-table-column prop="CreateTime1" label="申请时间" width="120" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.CreateTime1 ? row.CreateTime1.replace('T',' ') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="PaymentTime" label="发放时间" width="120" :show-overflow-tooltip="true" align="center" v-if="activeName2=='1'">
            <template slot-scope={row}>
              {{ row.PaymentTime ? row.PaymentTime.replace('T',' ') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="IncomeTaxMonth" label="申报月" width="120" :show-overflow-tooltip="true" align="center" v-if="activeName2=='1'">
          </el-table-column>
          <el-table-column label="操作" :width="activeName2=='2' ? '200px' : '150px'" v-if="(activeName2=='1' || activeName2=='2') && roleName!='客户在线'" align="center" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" v-if="activeName2=='1'" @click="downReceiptSingle(row)">下载回单</el-button>
                <el-button type="text" @click="editFailInfo(row)" v-if="activeName2=='2'">修改提交</el-button>
                <el-popconfirm title="请确定是否修改失败原因？" @confirm="editFailReason(row)" style="margin-left: 10px;" v-if="activeName2=='2'&&checkPermission(['salary_payment'],permissionLists)">
                  <el-button type="text" slot="reference">修改失败原因</el-button>
                </el-popconfirm>
                <el-popconfirm title="请确定是否登记失败？" @confirm="registFail(row)" style="margin-left: 10px;" v-if="activeName2=='1'&&checkPermission(['salary_payment'],permissionLists)">
                  <el-button type="text" slot="reference">登记失败</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="expData" border class="doc_table" v-loading="loading" :element-loading-text="loadingTxt ? loadingTxt : '加载中...'" style="width:100%" @selection-change="handleSelectionChange" v-if="activeName2=='5' && activeName=='已发薪'" :max-height="tableHeight-180">
          <el-table-column prop="createTime" label="创建时间" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.createTime ? row.createTime.replace('T',' ') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="msg2" label="操作人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="msg1" label="导出人数" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="downExpFile(row)">下载</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0 && activeName2!='5'" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
          <el-pagination v-if="totalCount>0 && activeName2=='5'" @current-change="currentChange2" :current-page.sync="listQuery2.pageNum" :page-size="Number(listQuery2.pageSize)" @size-change="handleSizeChange2" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="修改" :visible.sync="showEditFailInfo" width="550px">
      <el-form :model="formData" ref="formData" :rules="rules" label-width="110px" v-if="showEditFailInfo">
        <el-form-item label="商务合同主体">
          <div class="formItem">{{info.Subject}}</div>
        </el-form-item>
        <el-form-item label="客户名称">
          <div class="formItem">{{info.CustomerName}}</div>
        </el-form-item>
        <el-form-item label="姓名" prop="EmployeeName">
          <el-input v-model="formData.EmployeeName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="应发金额">
          <el-input v-model="info.IncludesTelephoneSubsidy" style="width:300px" size="small" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="实发金额">
          <div class="flex">
            <el-input v-model="info.IssuedThisMonth" style="width:300px" size="small" readonly disabled></el-input>
            <el-button type="text" @click="splitPay" v-if="canSplit">拆分发放</el-button>
          </div>
        </el-form-item>
        <el-form-item label="本次发放" prop="IssuedThisMonth" v-if="isSplitPay">
          <el-input v-model="formData.IssuedThisMonth" type="number" style="width:300px" size="small"></el-input>
          <div class="payTips" v-if="formData.IssuedThisMonth">注：剩 {{(info.IssuedThisMonth -  formData.IssuedThisMonth).toFixed(2)}} 元请“新增算薪”选择“其他”类型提交发放</div>
        </el-form-item>
        <el-form-item label="银行卡帐号" prop="BankAccount">
          <el-input v-model="formData.BankAccount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="DepositBank">
          <el-input v-model="formData.DepositBank" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditFailInfo = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEdit">提 交</el-button>
      </span>
    </el-dialog>
    <div class="salaryApproval_Dialog">
      <el-dialog width="500px" title="CBS打款成功" :visible.sync="innerVisibleRes">
        <div class="payResult flex">
          <div>打款成功人数： {{ successData.length }}</div>
          <div class="payAmount">打款成功金额： {{ PayrollSum }}</div>
        </div>
        <div class="wrapperTable">
          <el-table :data="successData" border class="doc_table" style="width:411px">
            <el-table-column prop="Sort" label="序号" width="50" align="center">
              <template slot-scope="scope">
                {{ (listQuery.pageNum - 1) * Number(listQuery.pageSize) + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="EmployeeName" label="姓名" width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="IssuedThisMonth" label="金额" width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="innerVisibleRes = false">确
            定</el-button>
        </span>
      </el-dialog>

      <el-dialog width="700px" title="选择发薪子公司银行账户" :visible.sync="innerVisibleCA">
        <div class="salaryPayingCompanyBox" v-if="bankList.length > 0">
          <div class="salaryPayingCompanyItem" v-for="(item, index) in bankList" :key="index">
            <div class="salaryPayingCompany">发薪公司：{{ item.CompanyName }}</div>
            <div class="salaryPayingCompany_radio">
              <!-- <el-radio-group v-model="item.payAccount" > -->
              <el-radio :label="bank.Account" v-for="bank in item.AccountList" :key="bank.Account" style="margin-bottom: 10px;" v-model="item.payAccount" @input="(val) => { inputChange(val, item, bank.OpeningBank) }">开户行：{{ bank.OpeningBank }} 帐号：{{
          bank.Account
        }}</el-radio>
              <!-- </el-radio-group> -->
            </div>
          </div>
        </div>
        <div v-else class="noAccountTips">暂无发薪子公司CBS银行账户</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="innerVisibleCA = false" size="small">取 消</el-button>
          <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="beforePay">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog width="700px" title="提交内部转款" :visible.sync="showInnerPay">
        <div class="salaryPayingCompanyBox" v-if="showInnerPay">
          <div class="salaryPayingCompanyItem">
            <div class="salaryPayingCompany">付款方：{{ paySubject }}</div>
            <div class="salaryPayingCompany_radio">
              <el-radio-group v-model="MainpayAccount">
                <el-radio :label="bank.Account" v-for="bank in BankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-if="bank.IsCbs">开户行：{{ bank.OpeningBank }} 帐号：{{ bank.Account
                }}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <!-- <div class="salaryPayingCompanyItem">
            <div class="salaryPayingCompany">付款方（垫支）：{{ dzCompany }}</div>
            <div class="salaryPayingCompany_radio">
              <el-radio-group v-model="ApplyDepositAccount">
                <el-radio :label="ApplyDepositAccount" style="margin-bottom: 10px;">开户行：{{ dzOpenBank }} 帐号：{{
          ApplyDepositAccount }}</el-radio>
              </el-radio-group>
            </div>
          </div> -->

          <div class="salaryPayingCompanyItem" v-for="(item, index) in payAccount2" :key="index">
            <div class="flex sb">
              <div class="salaryPayingCompany">收款方：{{ item.CompanyName }}</div>
              <div class="salaryPayingCompany" style="margin-right:30px"> 金额：￥{{ item.CompanyPayrollSum }}</div>
            </div>
            <div class="salaryPayingCompany_radio flex">
              <div>开户行：{{ item.payOpenBnak }}</div>
              <div>账号：{{ item.Account }}</div>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="showInnerPay = false" size="small">取 消</el-button>
          <el-button type="warning" @click="confirmPay" size="small">跳 过</el-button>
          <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmInnerPay">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- CBS普通代发 -->
    <el-dialog title="CBS普通代发" :visible.sync="cbsGeneralVisible" width="700px" class="d_replace_box">
      <div class="note_txt">注：联行号、开户行+开户地 任填一个即可</div>
      <el-form :model="replaceForm" ref="replaceData" :rules="replaceRules" label-width="110px">
        <el-form-item label="原开户行:" v-if="cbsGeneralVisible">
          <span>{{multipleSelection[0].DepositBank}}</span>
        </el-form-item>
        <el-form-item label="新开户行:">
          <el-input v-model="replaceForm.dtlRevBankName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户地:" prop="BankAccount">
          <el-cascader ref="regAddress" :props="propsAddress" size="small" style="width:100%" v-model="RegisteredAddress" placeholder="" :options="provinces" clearable filterable @change="changeAddress" @clear="clearAddress"></el-cascader>
        </el-form-item>
        <el-form-item label="银行联行号:">
          <el-input v-model="replaceForm.dtlCnapsCode" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div class="cbs_table_box">
        <el-table :data="replaceTableData" style="width:100%">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
              <span>{{Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="姓名" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.EmployeeName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="金额" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.IssuedThisMonth}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="开户行" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{replaceForm.dtlRevBankName}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="all_txt">合计 {{multipleSelection.length}} 人， {{totalMoney}} 元</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cbsGeneralVisible = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmReplace" :loading="paying">确 认</el-button>
      </span>
    </el-dialog>

    <!-- <el-dialog :visible.sync="showAllSign" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="isSigning">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">
          人员校验进行中，预计耗时1~3分钟，请耐心等待......
        </div>
        <div class="footer">
          <el-button type="danger" size="small" @click="StopCheck" :loading="isloading">终止校验</el-button>
        </div>
      </div>
      <div v-if="!isSigning">
        人员校验结束，其中
        <span class="num1 success"> {{checkSuccess}} </span>
        人校验成功，<span class="num1 red"> {{checkFail}} </span>人校验失败
        <span v-if="checkFail>0">
          ，可在 算薪结果明细 表格“错误信息”列查看错误信息，请修改人员信息后重新校验。
        </span>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isSigning">
        <el-button size="small" type="primary" v-preventReClick :loading="taxLoading" @click="continueGetTax">继续算税</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="showAllTax" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="isTaxing">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">算税进行中，预计耗时1~5分钟，请耐心等待.....</div>
        <div class="footer">
          <el-button type="danger" size="small" @click="StopTax" :loading="isloading">终止算税</el-button>
        </div>
      </div>
      <div v-if="!isTaxing">
        算税结束，其中
        <span class="num1 success"> {{taxSuccess}} </span>
        人算税成功，<span class="num1 red"> {{taxFail}} </span>
        人失败
        <span v-if="taxNo>0">，<span class="num1 red"> {{taxNo}} </span>
          人未算税</span>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isTaxing">
        <el-button size="small" @click="showAllTax = false">关闭</el-button>
      </span>
    </el-dialog> -->


    <el-dialog title="修改" :visible.sync="showEditFailReason" width="550px">
      <el-form label-width="110px" v-if="showEditFailReason">
        <el-form-item label="开户行" prop="DepositBank">
          <!-- <el-input v-model="failReason" style="width:300px" size="small"></el-input> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditFailReason = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  import datas from '../../store/mainArea';
  export default {
    data() {
      return {
        listQuery: {
          AttrMonth: '',
          PayrollCompany: '',
          ProjectName: '',
          ProcessState: '',
          Subject: '', //商务合同主体
          PayrollChannel: '', //发放途径
          PayrollNum: '', //发薪编号
          CustomerName: '', //客户名称
          Service: '', //客服
          StrAchieveowner: '', //业绩归属人
          SearchTimeType: '', //时间类型
          TaxBureauResults: '', //算税状态
          StartTime: '',
          Remark: '',
          EndTime: '',
          pageNum: 1,
          pageSize: 10,
        },
        showDropScreen: -1,
        tableData: [],
        formData: {
          Id: '',
          EmployeeName: '', //姓名
          BankAccount: '', //银行卡账号
          DepositBank: '', //开户行
        },
        showEditFailReason: false,
        // failForm:{
        //   failReason:'',
        //   id:'',
        // },
        rules: {
          EmployeeName: {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          },
          IncludesTelephoneSubsidy: {
            required: true,
            message: '请输入申请金额',
            trigger: 'blur'
          },
          IssuedThisMonth: {
            required: true,
            message: '请输入实发金额',
            trigger: 'blur'
          },
          BankAccount: {
            required: true,
            message: '请输入银行卡帐号',
            trigger: 'blur'
          },
          DepositBank: {
            required: true,
            message: '请输入开户行',
            trigger: 'blur'
          },
        },
        roletype: localStorage.loginRoletype,
        tableHeight: 0,
        multipleSelection: [],
        multipleSelection2: [],
        totalCount: 0,
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0,
        num6: 0,
        num7: 0,
        num8: 0,
        num9: 0,
        num10: 0,
        num11: 0,
        activeName: '待发薪',
        keyList: [],
        loading: false,
        showPayment: false, //打款弹窗
        innerVisibleCA: false, //提交CBS打款弹窗
        innerVisibleRes: false, //打款结果弹窗
        radio: '1',
        activeName2: '0',
        isSplitPay: false, //拆分发放
        showEditFailInfo: false, //修改失败人员信息
        permissionLists: [],
        failData: [],
        proNameList: [], //项目列表
        legList: [],
        isExpLoading: false,
        ProcessState: '',
        info: {},
        bankList: [], //发薪子公司银行账户列表
        payForm: {
          payAccount: [],
          id: '',
          ids: '',
          MainId: '',
          FailurePayAgain: '1'
        },
        listQuery2: {
          pageSize: 10,
          pageNum: 1,
          type: 5
        },
        PayrollSum: 0, //打款总金额
        expData: [],
        successData: [],
        isBtnLoading: false, //按钮加载状态
        type: '',
        isHandelLoading: false,
        paySubject: '',
        BankAccount: [],
        time: 0, //查询次数
        MainpayAccount: '',
        showInnerPay: false,
        isCbsLoading: false,
        cbsGeneralVisible: false,
        // cbs普通代发
        replaceForm: {
          dtlRevBankName: '', //开户行
          dtlCnapsCode: '', //联行号
          dtlRevBankArea: '', //省
          dtlRevBankCity: '', //市
        },
        totalMoney: 0, //总金额
        loadingTxt: '',
        ids: '',
        customerList: [], //客服列表
        replaceTableData: [],
        canSplit: false,
        RegisteredAddress: ["浙江省", "宁波市", "北仑区"], //开户地
        provinces: [], //省市区
        paying: false,
        roleName: localStorage.roleName,
        propsAddress: {
          label: "Name",
          value: "Name",
          children: "children",
          // checkStrictly: true
        },
        replaceRules: {
          EmployeeName: {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }
        },
        // taxId:'',
        // showAllSign: false, //第三步默认全员登记弹窗
        // isSigning: false, //登记中
        // showAllTax: false, //第三步默认全员计算个税弹窗
        // isTaxing: false, //计算个税中
        // checkFail: 0, //校验失败数量
        // checkSuccess: 0, //校验成功数量
        // taxSuccess: 0, //个税计算成功数量
        // taxFail: 0, //个税计算失败数量
        // taxNo: 0, //未算税个数
      }
    },
    created() {
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
        this.listQuery.ProcessState = this.$route.query.activeName;
        this.ProcessState = this.$route.query.activeName;
        this.listQuery.ProjectName = this.$route.query.projectName;
      }
      this.tableHeight = Number(document.body.clientHeight);
      this.getButtonPower();
      this.getNum2();
      // this.getProList();
      this.getlegalsubjectlist();
      this.getprovinces();
      if (this.activeName == '发薪失败') {
        this.activeName2 = '2';
        this.changeTab2()
      } else if (this.activeName == '已发薪归档') {
        this.changeTab()
      } else {
        this.getApplicationPayrollList();
      }
      this.getMemberList();
      this.IsFinancial();
      this.getZNum();
      this.getFailNum();
      this.getKeyList();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/calcSalary',
          powerEnName: 'sarary'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      //判断是否是财务
      IsFinancial() {
        xz.IsFinancial(this.roletype).then(res => {
          if (res.status == 'ok') {
            if (res.data) {
              this.GetFinancialProject();
            } else {
              this.getProList()
            }
          } else {
            this.getProList()
          }
        })
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then((res) => {
          this.provinces = res
        })
      },
      // CBS普通代发显示弹框
      generalDisHandle() {
        if (this.multipleSelection.length > 0) {
          this.replaceTableData = JSON.parse(JSON.stringify(this.multipleSelection)) //拷贝
          this.totalMoney = 0;
          let canPay = true;
          let payBank = this.multipleSelection[0].DepositBank;
          let payPro = this.multipleSelection[0].ProjectName;
          let arr = [];
          this.multipleSelection.forEach(element => {
            this.totalMoney = Number(this.totalMoney) + Number(element.IssuedThisMonth)
            arr.push(element.Id)
            if (payBank != element.DepositBank) {
              canPay = false
            }
            if (payPro != element.ProjectName) {
              canPay = false
            }
          });
          if (canPay) {
            this.RegisteredAddress = ["浙江省", "宁波市", "北仑区"];
            this.replaceForm = {
              dtlRevBankName: this.multipleSelection[0].DepositBank, //开户行
              dtlCnapsCode: '', //联行号
              dtlRevBankArea: '浙江省', //省
              dtlRevBankCity: '宁波市', //市
            }
            this.cbsGeneralVisible = true;
            this.ids = arr.toString();
          } else {
            this.$message.warning('所选中的代发人员开户行或者项目不同，不能代发')
          }
        } else {
          this.$message({
            type: 'warning',
            message: '请选择需代发数据'
          })
        }
      },
      // 确定cbs普通代发
      confirmReplace() {
        if (!this.replaceForm.dtlCnapsCode && !this.replaceForm.dtlRevBankName) {
          this.$message.warning('请填写联行号或者开户行')
        } else if (this.replaceForm.dtlRevBankName && !this.replaceForm.dtlRevBankArea) {
          this.$message.warning('请选择开户地')
        } else if (this.replaceForm.dtlCnapsCode && this.replaceForm.dtlRevBankName) {
          this.$message.warning('联行号和开户行只需要填写一个')
        } else {
          this.paying = true;
          let arr = [];
          this.multipleSelection.forEach((element, index) => {
            let data = {
              Id: element.Id,
              dtlRevBankName: this.replaceForm.dtlRevBankName, //开户行
              dtlCnapsCode: this.replaceForm.dtlCnapsCode, //联行号
              dtlRevBankArea: this.replaceForm.dtlRevBankArea, //省
              dtlRevBankCity: this.replaceForm.dtlRevBankCity, //市
            }
            arr.push(data)
            if (index == this.multipleSelection.length - 1) {
              let d = {
                ids: this.ids,
                parmList: arr
              }
              xz.failurePayAgain(d, this.roletype).then(res => {
                if (res.status == 'ok') {
                  this.$message.success('操作成功')
                  this.getFailedDetaiOrToPaylList();
                  this.paying = false;
                  this.cbsGeneralVisible = false;
                } else {
                  this.paying = false;
                  this.$message({
                    type: 'error',
                    message: res.msg,
                    duration: 5000
                  })
                }
              })
            }
          });
        }
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //财务  获取项目列表
      GetFinancialProject() {
        xz.GetFinancialProject(this.roletype).then(res => {
          if (res.status == 'ok') {
            this.proNameList = res.data;
          } else {
            this.proNameList = [];
          }
        })
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      currentChange2(val) {
        this.listQuery2.pageNum = Number(val);
        this.GetCalcTransientCostsList();
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery2.pageNum = 1;
        this.listQuery2.pageSize = val;
        this.GetCalcTransientCostsList();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        // this.getZNum();
        this.getList();
      },
      getList() {
        if ((this.activeName == '已发薪' || this.activeName == '已发薪归档') && this.activeName2 == '1') {
          this.getSucceedToPaylList();
        } else if (this.activeName == '发薪失败' && (this.activeName2 == '1' || this.activeName2 == '2' || this.activeName2 == '3' || this.activeName2 == '4')) {
          this.getFailedDetaiOrToPaylList();
        } else {
          this.getApplicationPayrollList();
          this.getNum2();
        }
      },
      getApplicationPayrollList() {
        this.loading = true;
        let pagename = this.activeName != '已发薪归档' ? 'getApplicationPayrollList95' : 'GetAppliPayrolArchiveList';
        xz.getApplicationPayrollList95(this.listQuery, this.roletype, pagename).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.loading = false;
          } else {
            this.$message.error('系统出错');
            this.totalCount = 0;
            this.tableData = [];
            this.loading = false;
          }
        })
      },
      getNum2() {
        xz.getApplicationPayrollListCount95(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.num1 = 0;
            this.num2 = 0;
            this.num3 = 0;
            this.num4 = 0;
            this.num5 = 0;
            this.num6 = 0;
            this.num7 = 0;
            // this.num8 = 0;
            this.num9 = 0;
            this.num11 = 0;
            if (res.data.collect1.length > 0) {
              res.data.collect1.forEach(element => {
                if (element.approverState == '待发薪') {
                  this.num5 = element.entNum
                } else if (element.approverState == '已发薪') {
                  this.num7 = element.entNum
                }
                // else if (element.approverState == '发薪失败') {
                //   this.num8 = element.entNum
                // } 
                else if (element.approverState == '退回记录') {
                  this.num9 = element.entNum
                } else if (element.approverState == '出纳确认') {
                  this.num4 = element.entNum
                } else if (element.approverState == '打款中') {
                  this.num11 = element.entNum
                }
              })
            }
            if (res.data.collect.length > 0) {
              res.data.collect.forEach(element => {
                if (element.approverState == '算薪') {
                  this.num1 = element.entNum
                } else if (element.approverState == '主管审批') {
                  this.num2 = element.entNum
                } else if (element.approverState == '业务审批') {
                  this.num3 = element.entNum
                } else if (element.approverState == '部分发薪') {
                  this.num6 = element.entNum
                }
              })
            }
            this.totalCount = res.data.totalcount;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        if (this.activeName == '算薪' || this.activeName == '安排资金') {
          this.$router.push({
            path: '/calcSalary',
            query: {
              activeName: this.activeName,
              projectName: this.listQuery.ProjectName
            }
          })
        } else if (this.activeName == '主管审批' || this.activeName == '业务审批' || this.activeName == '出纳确认') {
          this.$router.push({
            path: '/salaryApproval',
            query: {
              activeName: this.activeName,
              projectName: this.listQuery.ProjectName
            }
          })
        } else if (this.activeName == '待发薪' || this.activeName == '部分发薪' || this.activeName == '已发薪' || this.activeName == '已发薪归档' || this.activeName == '打款中') {
          this.activeName2 = '0';
          if (this.activeName == '已发薪归档') {
            this.listQuery.ProcessState = '已发薪'
          } else {
            this.listQuery.ProcessState = this.activeName;
          }
          this.ProcessState = this.activeName;
          this.getZNum();
          this.getList();
        } else if (this.activeName == '发薪失败') {
          this.activeName2 = '2';
          this.changeTab2()
        } else if (this.activeName == '退回记录') {
          this.$router.push({
            path: '/returnRecord'
          })
        } else if (this.activeName == '复核发薪') {
          this.$router.push({
            path: '/reviewPay'
          })
        }
      },
      //撤销
      revoke(row) {
        xz.withdrawClaim(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            // this.getZNum();
            this.getList();
            this.$message.success('撤销成功！')
          } else {
            // this.getZNum();
            this.getList();
            this.$message.error(res.msg);
          }
        })
      },
      edit(item) {

      },
      //确认新增/修改
      confirmSubmit() {
        this.$refs["salaryForm"].validate((valid) => {
          if (valid) {}
        })
      },
      viewDtl(row) {
        const routerUrl = this.$router.resolve({
          path: this.activeName == '已发薪' || this.activeName == '已发薪归档' ? '/salarySuccessDtl' : '/salaryDtl',
          query: {
            Id: row.Id,
            activeName: this.activeName
          }
        });
        window.open(routerUrl.href, "_blank");
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //确认打款
      confirmPay() {
        this.isBtnLoading = true;
        xz.cbsRemit(this.payForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isBtnLoading = false;
            this.innerVisibleCA = false;
            // this.innerVisibleRes = true;
          } else {
            this.isBtnLoading = false;
            this.$message({
              type: 'error',
              message: res.msg,
              duration: 8000
            })
          }
        })
      },
      beforePay() {
        let arr = [];
        let arr2 = [];
        this.bankList.forEach((element, index) => {
          if (element.payAccount) {
            let data = {
              CompanyName: element.CompanyName,
              Account: element.payAccount
            }
            arr.push(data)
            let data2 = {
              CompanyName: element.CompanyName,
              Account: element.payAccount,
              OpeningBank: element.OpeningBank,
              CompanyPayrollSum: element.CompanyPayrollSum,
              payOpenBnak: element.payOpenBnak
            }
            arr2.push(data2)
          }
          if (index == this.bankList.length - 1) {
            this.payForm.payAccount = arr;
            this.payAccount2 = arr2;
            // console.log('cc',this.payAccount2)
            if (this.type == 'all') {
              this.payForm.id = this.listQuery.id;
              this.payForm.ids = '';
            } else if (this.type == 'cbs') {
              this.payForm.id = '';
            }
            if (this.payForm.payAccount.length > 0) {
              this.innerVisibleCA = false;
              this.showInnerPay = true;
            } else {
              this.$message.warning('请选择发薪子公司银行账户')
            }
          }
        });
      },
      confirmInnerPay() {
        if (!this.MainpayAccount) {
          this.$message.warning('请选择付款账号')
        } else {
          this.isBtnLoading = true;
          let data = {
            payAccount: this.payForm.payAccount,
            id: this.payForm.id,
            ids: this.payForm.ids,
            MainId: this.payForm.MainId,
            MainpayAccount: this.MainpayAccount,
            ApplyDepositAccount: this.ApplyDepositAccount,
            FailurePayAgain: '1'
          }
          xz.cbsRemit(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.isBtnLoading = false;
              this.innerVisibleCA = false;
              this.showInnerPay = false;
              this.innerVisibleRes = true;
            } else {
              this.isBtnLoading = false;
              this.showInnerPay = false;
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 8000
              })
            }
          })
          // console.log(data)
        }
      },
      //关闭结果
      closeRes() {
        this.innerVisibleCA = false;
        // this.innerVisibleRes = false;
      },
      toPayment(row) {
        this.$router.push({
          path: '/paymentDtl',
          query: {
            Id: row.Id
          }
        })
      },
      getZNum() {
        xz.appropriatFundsList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.num10 = res.data.totalcount;
          } else {
            this.num10 = 0;
          }
        })
      },
      //导出列表
      exportList() {
        if (this.activeName == '已发薪' && this.activeName2 == '1') {
          let data;
          if (this.multipleSelection.length > 0) {
            let arr = [];
            this.multipleSelection.forEach((element, index) => {
              arr.push(element.Id)
              if (index == this.multipleSelection.length - 1) {
                data = {
                  Ids: arr.toString(),
                  IsExport: 1
                }
              }
            });
          } else {
            data = JSON.parse(JSON.stringify(this.listQuery))
            data.pageSize = 1000000;
            data.IsExport = 1;
          }
          this.isExpLoading = true;
          let pagename = this.activeName == '已发薪归档' ? 'GetSucceedToPaylArchiveList' : 'getSucceedToPaylList'
          xz.getSucceedToPaylList(data, this.roletype, pagename).then(res => {
            if (res.status == 'ok') {
              // let url = res.data;
              // let base64 = url.toString()
              // let byteCharacters = atob(
              //   base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
              // )
              // let byteNumbers = new Array(byteCharacters.length)
              // for (let i = 0; i < byteCharacters.length; i++) {
              //   byteNumbers[i] = byteCharacters.charCodeAt(i)
              // }
              // let byteArray = new Uint8Array(byteNumbers)
              // let blob = new Blob([byteArray], {
              //   type: `application/pdf`
              // })
              // let aLink = document.createElement("a")
              // aLink.download = '已发薪成功人员列表.xls' //这里写保存时的名称
              // aLink.href = URL.createObjectURL(blob)
              // aLink.click()
              this.$message.success('导出成功,请前往发薪成功导出列表查看')
              this.isExpLoading = false;
            } else {
              this.isExpLoading = false;
              this.$message.error(res.msg)
            }
          })

        } else if (this.activeName == '发薪失败' && (this.activeName2 == '2' || this.activeName2 == '3')) {
          let data = JSON.parse(JSON.stringify(this.listQuery));
          if (this.multipleSelection.length > 0) {
            let arr = [];
            this.multipleSelection.forEach((element, index) => {
              arr.push(element.Id)
              if (index == this.multipleSelection.length - 1) {
                data.ids = arr.toString();
              }
            });
          }
          data.IsExport = '1';
          data.pageSize = 100000;
          this.isExpLoading = true;
          xz.getFailedDetaiOrToPaylList(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              let url = res.data;
              let base64 = url.toString()
              let byteCharacters = atob(
                base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
              )
              let byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              let byteArray = new Uint8Array(byteNumbers)
              let blob = new Blob([byteArray], {
                type: `application/pdf`
              })
              let aLink = document.createElement("a")
              aLink.download = this.activeName + '列表.xls' //这里写保存时的名称
              aLink.href = URL.createObjectURL(blob)
              aLink.click()
              this.isExpLoading = false;
            } else {
              this.isExpLoading = false;
              this.$message.error(res.msg)
            }
          })
          delete this.listQuery.ids;
        } else {
          let data;
          if (this.multipleSelection2.length > 0) {
            let arr = [];
            this.multipleSelection2.forEach((element, index) => {
              arr.push(element.Id)
              if (index == this.multipleSelection2.length - 1) {
                data = {
                  Ids: arr.toString(),
                  IsExport: 1
                }
              }
            });
          } else {
            data = JSON.parse(JSON.stringify(this.listQuery));
            data.IsExport = '1';
            data.pageSize = 100000;
          }
          this.isExpLoading = true;
          console.log('导出列表', data)
          xz.getApplicationPayrollList95(data, this.roletype,'getApplicationPayrollList95').then(res => {
            if (res.status == 'ok') {
              let url = res.data;
              let base64 = url.toString()
              let byteCharacters = atob(
                base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
              )
              let byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              let byteArray = new Uint8Array(byteNumbers)
              let blob = new Blob([byteArray], {
                type: `application/pdf`
              })
              let aLink = document.createElement("a")
              aLink.download = this.activeName + '列表.xls' //这里写保存时的名称
              aLink.href = URL.createObjectURL(blob)
              aLink.click()
              this.isExpLoading = false;
            } else {
              this.isExpLoading = false;
              this.$message.error(res.msg)
            }
          })
        }

      },
      changeTab2() {
        if (this.activeName2 == '0') {
          this.listQuery = {
            AttrMonth: '',
            PayrollCompany: '',
            ProjectName: '',
            ProcessState: this.activeName,
            pageNum: 1,
            pageSize: this.listQuery.pageSize,
          }
          this.getApplicationPayrollList()
          this.getNum2();
        } else if (this.activeName2 == '1') {
          this.listQuery = {
            pageNum: 1,
            pageSize: this.listQuery.pageSize,
            CardId: '',
            PayrollNum: '',
            BankAccount: '',
            PhoneNum: '',
            EmployeeName: '',
          }
          this.getSucceedToPaylList()
        } else if (this.activeName2 == '2' || this.activeName2 == '3' || this.activeName2 == '4') {
          this.listQuery = {
            pageNum: 1,
            pageSize: 10, //临时改动
            Type: this.activeName2 == '4' ? '3' : this.activeName2 == '2' ? '1' : '2',
            CardId: '',
            PayrollNum: '',
            BankAccount: '',
            PhoneNum: '',
            EmployeeName: '',
            IsExport: '0'
          }
          this.getFailedDetaiOrToPaylList()
        } else if (this.activeName2 == '4') {
          this.listQuery = {
            AttrMonth: '',
            PayrollCompany: '',
            ProjectName: '',
            ProcessState: '打款中',
            pageNum: 1,
            pageSize: 10,
          }
          this.getApplicationPayrollList()
          this.getNum2();
        } else if (this.activeName2 == '5') {
          this.listQuery2.pageNum = 1;
          this.GetCalcTransientCostsList();
        }
      },
      GetCalcTransientCostsList() {
        this.loading = true;
        xz.GetCalcTransientCostsList(this.listQuery2).then(res => {
          if (res.status == 'ok') {
            this.expData = res.data.data;
            this.totalCount = res.data.count;
            this.loading = false;
          } else {
            this.expData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //获取成功列表
      getSucceedToPaylList() {
        this.loading = true;
        let pagename = this.activeName == '已发薪归档' ? 'GetSucceedToPaylArchiveList' : 'getSucceedToPaylList'
        xz.getSucceedToPaylList(this.listQuery, this.roletype,pagename).then(res => {
          if (res.status == 'ok') {
            this.totalCount = res.data.totalcount;
            this.failData = res.data.data;
            this.loading = false;
          } else {
            this.$message.error(res.msg);
            this.totalCount = 0;
            this.failData = [];
            this.loading = false;
          }
        })
      },
      //获取失败列表
      getFailedDetaiOrToPaylList() {
        this.loading = true;
        this.failData = [];
        xz.getFailedDetaiOrToPaylList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.failData = res.data.data;
            this.num8 = res.data.totalcount;
            this.loading = false;
            this.totalCount = res.data.totalcount;
          } else {
            this.$message.error(res.msg);
            this.totalCount = 0;
            this.failData = [];
            this.loading = false;
          }
        })
      },
      getFailNum() {
        let data = {
          pageNum: 1,
          pageSize: 0, //临时改动
          Type: '1',
          CardId: '',
          PayrollNum: '',
          BankAccount: '',
          PhoneNum: '',
          EmployeeName: '',
          IsExport: '0'
        }
        xz.getFailedDetaiOrToPaylList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.num8 = res.data.totalcount;
          } else {
            this.num8 = 0
          }
        })
      },
      //下载回单 单个
      downReceiptSingle(row) {
        this.loading = true;
        let d = {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          SalaryDetails: row.Id
        }
        xz.downloadEleReceiptPayNum(d).then(res => {
          if (res.status == 'ok') {
            let time = row.CTotalPayrolls < 1000 ? 20000 : 30000;
            this.loadingTxt = time < 30000 ? '生成中...' : '生成中，发薪人数较多，请耐心等待1~3分钟';
            setTimeout(() => {
              this.time = 0;
              this.getpdfcont(res.data)
            }, 10000);
          } else {
            this.loading = false;
            this.loadingTxt = '';
            this.$message.error(res.msg)
          }
        })
      },
      handleSelectionChange2(val) {
        this.multipleSelection2 = val;
      },
      downReceiptBatch() {
        if (this.activeName2 == '0') {
          if (this.multipleSelection2.length > 0) {
            let arr = [];
            this.multipleSelection2.forEach(e => {
              arr.push(e.Id)
            });
            this.downReceipt(arr.toString(), 30000)
          } else {
            this.$message.warning('请选择数据')
          }
        } else {
          if (this.multipleSelection.length > 0) {
            this.loading = true;
            let arr = [];
            this.multipleSelection.forEach(e => {
              arr.push(e.Id);
            });
            let d = {
              userid: Cookies.get("userid-b"),
              roletype: localStorage.loginRoletype,
              SalaryDetails: arr.toString()
            }
            xz.downloadEleReceiptPayNum(d).then(res => {
              if (res.status == 'ok') {
                this.loadingTxt = '生成中，发薪人数较多，请耐心等待1~3分钟';
                setTimeout(() => {
                  this.time = 0;
                  this.getpdfcont(res.data)
                }, 10000);
              } else {
                this.loading = false;
                this.loadingTxt = '';
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.warning('请选择数据')
          }
        }
      },
      //下载回单整批
      downReceipt(Id, nums) {
        this.loading = true;
        let d = {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          Id
        }
        xz.downloadEleReceiptPayNum(d).then(res => {
          if (res.status == 'ok') {
            let time = nums < 1000 ? 20000 : 30000;
            this.loadingTxt = time < 30000 ? '生成中...' : '生成中，发薪人数较多，请耐心等待1~3分钟';
            setTimeout(() => {
              this.time = 0;
              this.getpdfcont(res.data)
            }, 10000);
          } else {
            this.loading = false;
            this.loadingTxt = '';
            this.$message.error(res.msg)
          }
        })
      },
      getpdfcont(business) {
        this.time++;
        let d = {
          business
        }
        xz.getpdfcont(d).then(r => {
          if (r.status == 'ok') {
            this.loading = false;
            this.loadingTxt = '';
            let url = r.data;
            const aTag = document.createElement('a')
            aTag.href = url
            aTag.click();
          } else {
            if (this.time < 18) {
              setTimeout(() => {
                this.getpdfcont(business)
              }, 10000);
            } else {
              this.$message.error(r.msg)
              this.loading = false;
              this.loadingTxt = '';
            }
          }
        })
      },
      //获取关键词列表
      getKeyList() {
        let data = {
          parentId: 53
        }
        xz.AdvanceFun(data, 'GetDicList').then(res => {
          if (res.status == 'ok') {
            this.keyList = res.data
          } else {
            this.keyList = [];
          }
        })
      },
      //修改信息
      editFailInfo(row) {
        this.info = row;
        this.isSplitPay = false;
        if (this.info.PayErrMsg != undefined && this.info.PayErrMsg) {
          this.canSplit = false;
          this.keyList.forEach(e => {
            if (this.info.PayErrMsg.indexOf(e.name) > -1) {
              this.canSplit = true
            }
          });
        } else {
          this.canSplit = false;
        }
        this.showEditFailInfo = true;
        this.formData = {
          Id: row.Id,
          EmployeeName: row.EmployeeName, //姓名
          BankAccount: row.BankAccount, //银行卡账号
          DepositBank: row.DepositBank, //开户行
        }
      },
      //确认修改
      confirmEdit() {
        this.$refs["formData"].validate((valid) => {
          if (valid) {
            xz.modifyPaymentFailure(this.formData, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功');
                this.showEditFailInfo = false;
                this.getFailedDetaiOrToPaylList();
              } else {
                this.$message.error(res.msg)
                this.showEditFailInfo = false;
              }
            })
          }
        })
      },
      //手工登记成功/失败
      handel(type) {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach(element => {
            arr.push(element.Id)
          });
          let data = {
            ids: arr.toString(),
            success: type
          }
          xz.FailurePayAgainHandMade(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('操作成功')
              this.loading = false;
              this.getFailedDetaiOrToPaylList();
            } else {
              this.loading = false;
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 5000
              })
            }
          })
        } else {
          this.$message.warning('请至少选择一位员工')
        }
      },
      //批量提交
      batchSubmit() {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach(element => {
            arr.push(element.Id)
          });
          let ids = arr.toString();
          xz.financeFailureProcessing(ids, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('操作成功')
              this.getFailedDetaiOrToPaylList();
              this.loading = false;
            } else {
              this.loading = false;
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 5000
              })
            }
          })
        } else {
          this.$message.warning('请至少选择一位提交')
        }
      },
      //发薪失财人员归档
      FailurePayToArchive() {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach(element => {
            arr.push(element.Id)
          });
          let ids = arr.toString();
          xz.failurePayToArchive(ids, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('操作成功')
              this.getFailedDetaiOrToPaylList();
              this.loading = false;
            } else {
              this.loading = false;
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 5000
              })
            }
          })
        } else {
          this.$message.warning('请至少选择一位归档')
        }
      },
      //重新打款
      rePay() {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach(element => {
            arr.push(element.Id)
          });
          let ids = arr.toString();
          let data = {
            ids,
            parmList: []
          }
          xz.failurePayAgain(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('操作成功')
              this.getFailedDetaiOrToPaylList();
              this.loading = false;
            } else {
              this.loading = false;
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 5000
              })
            }
          })
        } else {
          this.$message.warning('请至少选择一位打款')
        }
      },
      //重选账户发薪
      selectRePay() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          let canPay = true;
          this.paySubject = this.multipleSelection[0].Subject;
          // this.payForm.MainId = '730ebd1c-3f75-4609-ac4c-49054e2325cb';
          this.payForm.MainId = this.multipleSelection[0].ParentId;
          try {
            this.multipleSelection.forEach(element => {
              if (this.paySubject != element.Subject) {
                this.$message.warning('不是同一发薪主体');
                canPay = false;
                throw Error('termination')
              } else {
                arr.push(element.Id)
              }
            });
          } catch (e) {}
          if (canPay) {
            this.getCompfinanceSet();
            this.payForm.ids = arr.toString();
            let data = {
              ids: arr.toString(),
              FailurePayAgain: '1'
            }
            this.successData = this.multipleSelection;
            xz.selectPayrollBankAccount(data, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.bankList = res.data.RetList;
                this.bankList.forEach(element => {
                  this.$set(element, 'payAccount', '');
                  this.$set(element, 'payOpenBnak', '');
                  element.AccountList.forEach(e => {
                    if (e.IsDefault != undefined && e.IsDefault == '1') {
                      this.$set(element, 'payAccount', e.Account);
                      this.$set(element, 'payOpenBnak', e.OpeningBank);
                    }
                  });
                });
                this.PayrollSum = res.data.PayrollSum;
                this.innerVisibleCA = true;
                console.log(this.bankList)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg,
                  duration: 5000
                })
              }
            })
          }

        } else {
          this.$message.warning('请至少选择一位提交')
        }
      },
      //获取主体银行账户
      getCompfinanceSet() {
        xz.getCompfinanceSet(this.paySubject, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (!res.data.BankAccountJ) {
              this.BankAccount = []
            } else {
              res.data.BankAccountJ.forEach(element => {
                if (element.IsDefault != undefined && element.IsDefault == '1') {
                  this.MainpayAccount = element.Account
                }
              });
              this.BankAccount = res.data.BankAccountJ;
            }
          } else {
            this.BankAccount = [];
          }
        })
      },
      //登记失败
      registFail(row) {
        let data = {
          MainId: row.ParentId,
          ids: row.Id
        }
        xz.registerRemitFail(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('操作成功')
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.msg,
              duration: 5000
            })
          }
        })
      },
      changeAddress(val) {
        console.log(val)
        this.replaceForm.dtlRevBankArea = val[0];
        this.replaceForm.dtlRevBankCity = val[1];
        this.$refs.regAddress._data.dropDownVisible = false;
      },
      clearAddress() {
        this.RegisteredAddress = []
        this.replaceForm.dtlRevBankArea = '';
        this.replaceForm.dtlRevBankCity = '';
      },
      // 获取客服列表
      getMemberList(type) {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      splitPay() {
        this.$set(this.formData, 'IssuedThisMonth', '')
        this.isSplitPay = true;
      },
      editFailReason(row) {
        this.loading = true;
        let str = `?id=${row.Id}`
        xz.ArdCurStatGetFun('updatePayErrMsgByID', str).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.$message.success("操作成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      // taxCheck(row) {
      //   this.taxId = row.Id
      //   this.showAllSign = true;
      //   this.isSigning = true;
      //   let data = {
      //     issend: "true",
      //     entname: row.Subject,
      //     datestr: this.baseInfo.IncomeTaxMonth,
      //     userid: Cookies.get("userid-b"),
      //     id: this.zeroId
      //   }
      //   xz.senduseralltoxft(data).then(res => {})
      //   clearInterval(this.interval);
      //   this.getZeroStatus('');
      //   setTimeout(() => {
      //     this.getZeroStatus('');
      //   }, 3000);
      //   this.intervalNum = 0;
      //   this.interval = setInterval(this.RefreshZero, 10000)
      // },
      exportSuccessDtl() {
        this.isExpLoading = true;
        let d = {
          pageSize: 1000000,
          pageNum: 1,
          type: 5
        }
        xz.AdvanceExpFun(d, 'GetCalcTransientCostsList').then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = '已发薪成功人员列表.xls' //这里写保存时的名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isExpLoading = false;
          } else {
            this.isExpLoading = false;
            this.$message.error(res.msg)
          }
        })
      },
      downExpFile(row) {
        let url = this.$store.state.EMP.imgPath + row.msg;
        const aTag = document.createElement('a')
        aTag.href = url;
        // aTag.setAttribute('download', row.name);
        aTag.click();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .cbs_table_box {
    max-height: 300px;
    overflow-y: auto;
  }

  .all_txt {
    font-size: 14px;
    color: #606266;
    margin-top: 10px;
  }

  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .basicInfo {
    flex-wrap: wrap;
    margin-bottom: 15px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    width: 170px;
    line-height: 32px;
  }

  .salaryPayingCompanyItem {
    margin-bottom: 30px;
  }

  .salaryPayingCompany {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .salaryPayingCompany_radio {
    padding-left: 30px;
  }

  .payResult {
    margin-bottom: 20px;
  }

  .payAmount {
    margin-left: 30px;
  }

  .formItem {
    width: 300px
  }

  .payTips {
    color: red;
    padding-left: 20px;
    font-size: 14px;
  }

  .note_txt {
    font-size: 13px;
    color: red;
    margin-bottom: 5px;
  }
</style>
<style>
  .d_replace_box .el-dialog__body {
    padding: 10px 20px;
  }

  .page_salary .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salary .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salary .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salary .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salary .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .salaryApproval_Dialog .el-dialog__body {
    padding-top: 10px;
  }

  .salaryPayingCompany_radio .el-radio {
    display: block;
    margin: 10px 0;
  }

  .wrapperTable .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .wrapperTable th.el-table__cell {
    padding: 8px 0 !important;
  }

  #tab-算薪 {
    /* background: rgb(255, 199, 206); */
    background: #FFFF00;
    /* color: #fff; */
  }

  #tab-安排资金 {
    /* background: rgb(255, 199, 206); */
    background: #FFFF00;
    /* color: #fff; */
  }

  .page_salary .el-breadcrumb {
    min-width: 136px;
  }
</style>